export default __webpack_public_path__ + "static/media/shield.5360e4ea.svg";